export class SetAccountingProviderStateFromAccountingConnection {
  static readonly type = '[Accounting] SetAccountingState from AccountingProvider';
}

export class SetAccountingProviderStateFromSelectingTenant {
  static readonly type = '[Accounting] SetAccountingState from Selecting Tenant';
}

export class SetAccountingProviderStateFromSelectingSourceAccount {
  static readonly type = '[Accounting] SetAccountingState from Source Account';
}

export class SetAccountingProviderStateFromTransactionSyncFailure {
  static readonly type = '[Accounting] SetAccountingState from Transaction Sync Failure';
}

export class StartPollingAccountingConnectionStatus {
  static readonly type = '[Accounting] Start Polling Accounting Connection Status';
}

export class StopPollingAccountingConnectionStatus {
  static readonly type = '[Accounting] Stop Polling Accounting Connection Status';
}

export class ClearAccountingState {
  static readonly type = '[Accounting] Reset Accounting State';
}

export class LoadTrackingCategories {
  static readonly type = '[Accounting] Load Tracking Categories';
  constructor(public forceRefresh: boolean = false) {}
}

export class LoadTaxRates {
  static readonly type = '[Accounting] Load Tax Rates';
  constructor(public forceRefresh: boolean = false) {}
}
